import { liveChatButtonSelected } from 'lib/gaTracking/crossPageEvents';
import { getLiveChatButton, getAreAgentsAvailable } from 'lib/liveChat';

export const trackLiveChatClick = (event: MouseEvent) => {
  const helpButton = getLiveChatButton();
  const isClickOnHelpButton = helpButton === event.target || helpButton?.contains(event.target as Node);

  if (isClickOnHelpButton) {
    liveChatButtonSelected(getAreAgentsAvailable());
  }
};
